import debounce from 'lodash/debounce';
import { useDispatch } from 'react-redux';
import { ListItem, ListItemLabel } from 'palette/List';
import { Toggle } from 'palette/Toggle';
import { toggleFilter } from '@common/Filters/actions/filtersActions';
import { ColorFilterLabel } from '@common/Filters/components/ColorFilterLabel';
import { useTranslation } from '@common/Hooks/useTranslation';
import { BEMBlock } from '@helpers/classnames';

import './FiltersListItemMobile.scss';

export function FiltersListItemMobile({
    item,
    customClick
}) {
    const dispatch = useDispatch();
    const translate = useTranslation();

    const [, BEMElement] = BEMBlock('filters-list-item-mobile');

    const {
        name, value, filterType, isSelected, description
    } = item;

    const label = translate(name);

    const filterClick = debounce(() => {
        dispatch(toggleFilter(item));
    }, 250, {
        leading: true,
        trailing: false
    });

    return (
        <>
            {description && <div className={BEMElement('list-item-description')}>{description}</div>}
            <ListItem
                className={BEMElement('list-item')}
                isActive={isSelected}
                onClick={customClick || filterClick}
            >
                <ListItemLabel>
                    {
                        filterType === 'color' ? (
                            <ColorFilterLabel
                                isChecked={isSelected}
                                label={label}
                                value={value}
                            />
                        ) : (
                            <Toggle
                                id={label}
                                isChecked={isSelected}
                                label={label}
                                variant="checkbox"
                            />
                        )
                    }
                </ListItemLabel>
            </ListItem>
        </>
    );
}
